import { render, staticRenderFns } from "./mobile-button.vue?vue&type=template&id=d531bf5e&scoped=true&"
import script from "./mobile-button.vue?vue&type=script&lang=js&"
export * from "./mobile-button.vue?vue&type=script&lang=js&"
import style0 from "./buttons.scss?vue&type=style&index=0&id=d531bf5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d531bf5e",
  null
  
)

export default component.exports